// ** Initial State

const initialState = {
  menuRowsHeight: [],
}

const menuRowsHeightReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MENU_ROWS_HEIGHT':
      return { ...state, menuRowsHeight: action.heights }
    default:
      return state
  }
}

export default menuRowsHeightReducer
